import AOS from 'aos';
import Bowser from 'bowser';
import $ from 'jquery';
import Cookies from 'js-cookie';
import throttle from 'lodash/throttle';
import queryString from 'query-string';
import Skrollr from 'skrollr';
import Velocity from 'velocity-animate';
import WOW from 'wow.js';
import initShareTooltip from '../components/shareTooltip';
import {post} from '../util/request';
import scrollLock from '../util/scrollLock';
import {smoothScrollToTarget} from '../util/smoothScroll';
import initSliderAnimations from './slider';
import {setCreateErrorElement, setHandleFocus, setupFormValidation} from '@brainstation/constraint-validation';
import '../components/filePicker';


function initCarouselAnimations() {
  initSliderAnimations('slider', 'slide', 'slide__image');
  initSliderAnimations('kg-blocks-slider', 'kg-blocks-slider__slide', 'kg-blocks-slider__image');
}

function initMainNav() {
  // mobile menu toggle
  $('.kg-top-nav__mobile-toggle').on('click', function (event) {
    const $header = $('.kg-header');
    $header.toggleClass('open');
    $(event.currentTarget).attr('aria-expanded', $header.hasClass('open'));
    scrollLock.toggle();
  });

  // menu closes when scrolling down and reveals when scrolling up
  const $header = $('.kg-header__wrapper');
  const $researchNav = $('.research-post__sidebar-container');
  const headerHeight = $header[0].offsetHeight;
  const animateLeftNav = window.innerWidth >= 992;
  let lastScrollTop = 0;
  let delta = 15;

  // checks if the header is at the top of the screen
  function checkHeaderTop(scrollTop) {
    if ($('.kg-header').attr('data-lock')) {
      return;
    }

    if (scrollTop < headerHeight) {
      $('.kg-header').addClass('kg-header--top');
      return true;
    } else {
      $('.kg-header').removeClass('kg-header--top');
      return false;
    }
  }

  // hides menu when scrolling down
  function onScrollDown(lastScrollTop, scrollTop) {
    if ($('.kg-header').attr('data-lock')) {
      return;
    }

    if (
      $header.hasClass('kg-header--hidden') ||
      $header.hasClass('velocity-animating') ||
      scrollTop <= 0 ||
      scrollTop + window.innerHeight >= document.documentElement.scrollHeight
    ) {
      lastScrollTop = scrollTop;
      return;
    }

    $('.kg-top-nav__dropdown, .kg-header__overlay').hide();

    // Scroll Down
    Velocity.animate($header, {
      translateY: '-100px',
      duration: '50',
      begin: function () {
        $header.removeClass('kg-header--revealed');
      },
    }).then(function () {
      $header.addClass('kg-header--hidden');
    });

    if (animateLeftNav) {
      // Animate the left nav in the research + insights section, if it exists
      Velocity.animate(
        $researchNav,
        {
          top: '0px',
          duration: '50',
        },
        {
          queue: false,
        }
      );
    }
  }

  // reveals menu when scrolling up
  function onScrollUp(lastScrollTop, scrollTop) {
    if ($('.kg-header').attr('data-lock')) {
      return;
    }

    if (
      $header.hasClass('kg-header--revealed') ||
      $header.hasClass('velocity-animating')
    ) {
      lastScrollTop = scrollTop;
      return;
    }

    // Scroll Up
    Velocity.animate($header, {
      translateY: '0px',
      duration: '50',
      begin: function () {
        $header.removeClass('kg-header--hidden');
        checkHeaderTop(scrollTop);
      },
    }).then(function () {
      $header.addClass('kg-header--revealed');
      checkHeaderTop(scrollTop);
    });

    if (animateLeftNav) {
      Velocity.animate(
        $researchNav,
        {
          top: `${headerHeight}px`,
          duration: '50',
        },
        {
          queue: false,
        }
      );
    }
  }

  function doScroll() {
    var scrollTop = window.pageYOffset;

    if (Math.abs(lastScrollTop - scrollTop) <= delta) {
      return;
    }

    if (scrollTop > lastScrollTop) {
      onScrollDown(lastScrollTop, scrollTop);
    } else {
      checkHeaderTop(scrollTop);
      onScrollUp(lastScrollTop, scrollTop);
    }

    lastScrollTop = scrollTop;
  }

  // throttle scroll method with underscore's throttle method
  $(window).scroll(throttle(doScroll));
}

function initLegacySkrollr() {
  const s = Skrollr.init({
    forceHeight: false,
  });

  // don't do Skrollr on mobile
  if (s.isMobile()) {
    s.destroy();
  } else {
    $(window).on('load', s.refresh);
  }
}

function initScrollAnimations() {
  AOS.init({
    duration: 800,
    once: true,
  });
}

function initWOW() {
  new WOW().init();
}

// allow the dropdowns to be tabbed through and make sure the main background goes white
function initNavDropdowns() {
  const header = $('.kg-header');
  const navDropdownContainer = $('.kg-top-nav__with-dropdown');
  const navBreakpoint = 850; // Same as $nav-breakpoint sass variable

  navDropdownContainer.on('focusin mouseenter', function (event) {
    if (window.innerWidth <= navBreakpoint) return;

    $(this)
      .find('.kg-top-nav__main-link__with-dropdown')
      .addClass('kg-top-nav__main-link__with-dropdown--open');
    $(this).find('.kg-top-nav__dropdown').css('display', 'block');

    Velocity.animate($(this).find('.kg-top-nav__dropdown'), {
      opacity: 1,
      duration: '350ms',
      easing: 'linear',
    });

    if (event.type !== 'focusin') {
      Velocity.animate(
        $(this).find('.kg-top-nav__dropdown__content'),
        {
          opacity: 1,
          translateY: ['0%', '10%'],
        },
        {
          duration: '250ms',
          delay: '100ms',
        }
      );
    }

    if (!header.hasClass('kg-header--fill')) {
      header.addClass('kg-header--fill');
      Velocity.animate(
        $('.kg-header__overlay'),
        {opacity: 1, duration: '150ms'},
        {display: 'block'}
      );
    }
  });

  navDropdownContainer.on('focusout mouseleave', function (e) {
    if (window.innerWidth <= navBreakpoint) return;

    if (!$(e.relatedTarget).closest(this).length) {
      $(this)
        .find('.kg-top-nav__main-link__with-dropdown')
        .removeClass('kg-top-nav__main-link__with-dropdown--open');
      $(this).find('.kg-top-nav__dropdown').css('display', '');
      $(this).find('.kg-top-nav__dropdown').css('opacity', '');
      $(this).find('.kg-top-nav__dropdown__content').css('opacity', '');
      Velocity($(this).find('.kg-top-nav__dropdown'), 'stop');
      Velocity($(this).find('.kg-top-nav__dropdown__content'), 'stop');

      if (header.hasClass('kg-header--fill')) {
        header.removeClass('kg-header--fill');
        $('.kg-header__overlay').hide();
      }
    }
  });

  // Intializing dropdowns for mobile
  navDropdownContainer.on('click', function () {
    if (window.innerWidth > navBreakpoint) return;

    $(this)
      .find('.kg-top-nav__main-link__with-dropdown')
      .toggleClass('kg-top-nav__main-link__with-dropdown--open');
    $('.kg-top-nav__dropdown').slideToggle(400);
  });
}

function initInputElements() {
  const didInitialize = Symbol('initialized-input');

  // handle the label moving and color change when the contact form is used
  $('[data-kg-styled-input]')
    .each(function (i, el) {
      if (el[didInitialize]) {
        return;
      }

      el[didInitialize] = true;

      let isFocused = document.activeElement === el;
      let hasValue = !!el.value;

      function render() {
        let isActive = isFocused || hasValue;
        el.classList.toggle('modified', isActive);
      }

      render();

      $(el).on('focus', () => {
        isFocused = true;
        render();
      });
      $(el).on('blur', () => {
        isFocused = false;
        render();
      });
      $(el).on('input change', (e) => {
        hasValue = !!e.target.value;
        render();
      });
    });

  // dynamically grow textareas
  $('[data-kg-styled-textarea]').each(function () {
    var offset = this.offsetHeight - this.clientHeight;

    function resizeTextarea(el) {
      $(el)
        .css('height', 'auto')
        .css('height', el.scrollHeight + offset);
    }

    $(this).on('keyup input', function () {
      resizeTextarea(this);
    });
  });
}

function checkTrackingQuery() {
  const qs = queryString.parse(location.search);

  // if any of these keys are in the query string
  if (qs.utm_keyword || qs.utm_source || qs.utm_campaign) {
    Cookies.set('utm_data', qs);
  }
}

function initSmoothScrollingLinks() {
  $('a[href*="#"]').each((i, el) => {
    const [url, fragment] = el.href.split('#');

    if (url === location.origin + location.pathname) {
      $(el).on('click', (event) => smoothScrollToTarget(event, fragment));
    }
  });
}

function initContactForm() {
  function addTrackingValuesToContactForm(formEl) {
    const utmData = Cookies.getJSON('utm_data');

    if (utmData) {
      Object.keys(utmData).forEach((key) => {
        formEl.append(
          `<input name='${key}' value='${utmData[key]}' type='hidden' />`
        );
      });
    }
  }

  $('[data-contact-form]').each((i, el) => addTrackingValuesToContactForm($(el)));
}

function initCandidateApplicationForm() {

  const toggleErrorState = (formEl, enable = false, message = 'Something went wrong. Try again?') => {
    const errorMsgEl = formEl.querySelector('[data-form-error]');

    if (enable) {
      errorMsgEl.innerText = message;
    }
    errorMsgEl.classList.toggle('hidden', !enable);

    if (enable) {
      errorMsgEl.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  };


  /**
   * Locking the form means disabling inputs and the submit button.
   * You can also clear all inputs with this method.
   * @param {HTMLFormElement} formEl the form element
   * @param {boolean} shouldLock should you lock the form?
   * @param {boolean} clearInputs clear/reset all fields?
   */
  const lockForm = (formEl, shouldLock = false, clearInputs = false) => {
    const formInputs = formEl.querySelectorAll('input');
    const submitButtonEl = formEl.querySelector('button[type="submit"]');

    formInputs.forEach((inp) => {
      if (shouldLock) {
        inp.setAttribute('disabled', shouldLock);
        inp.setAttribute('readonly', shouldLock);
      } else {
        inp.removeAttribute('readonly');
        inp.removeAttribute('disabled');
      }
    });

    if (shouldLock) {
      submitButtonEl.setAttribute('disabled', shouldLock);
    } else {
      submitButtonEl.removeAttribute('disabled');
    }

    if (clearInputs) {
      formEl.reset();
    }
  };

  function handleFormSubmit(e) {
    e.preventDefault();

    // compile form values into a FormData object for submission
    let formData = new FormData(e.target);

    // lock the form and prevent any more changes till data is extracted and submission happens
    lockForm(e.target, true, false);
    // add page title as the referrer
    formData.append('referrer', document.title);

    return post(
      e.target.getAttribute('action'),
      null,
      {
        body: formData,
      },
      false,
      true
    )
      .then(async (resp) => {
        if (!resp.ok) {
          lockForm(e.target, false, false);

          try {
            const {message} = await resp.json();
            toggleErrorState(e.target, true, message);
          } catch (err) {
            console.error(err);
            toggleErrorState(e.target, true);
          }

          return;
        }

        // update UI
        lockForm(e.target, false, true);

        let redirectUrl = e.target.getAttribute('data-redirect-url');
        let currentStateSelector = e.target.getAttribute('data-current-state-selector');
        let changeStateSelector = e.target.getAttribute('data-state-change-selector');

        if (redirectUrl) {
          window.location = redirectUrl;

          return Promise.resolve(resp);
        }

        if (currentStateSelector && changeStateSelector) {
          let currentStateEl = document.querySelector(currentStateSelector);
          let changeStateEl = document.querySelector(changeStateSelector);

          if (!currentStateEl || !changeStateEl) {
            return Promise.reject(resp);
          }

          document.querySelector(currentStateSelector).classList.toggle('hidden', true);
          document.querySelector(changeStateSelector).classList.toggle('hidden', false);

          return Promise.resolve(resp);
        }

        return Promise.reject(resp);
      })
      .catch((err) => {
        console.error(err);

        // update UI
        lockForm(e.target, false, false);
        toggleErrorState(e.target, true);
      });
  }

  function setupApplicationForm() {
    const form = document.querySelector('[data-application-form] form');

    if (!form) {
      return;
    }

    form.addEventListener('submit', (e) =>
      handleFormSubmit(e)
    );

    // emulate existing error placement logic so it doesn't conflict with bar styling for inputs
    setCreateErrorElement(form, (element, errorMessage) => {
      const errorElement = document.createElement('div');

      errorElement.classList.add('application-form__form-field-error-container');
      errorElement.classList.add('field-validation-error');
      errorElement.dataset.formFieldErrorContainer = 'true';
      errorElement.innerText = errorMessage;

      element.parentElement.appendChild(errorElement);

      return errorElement;
    });
    setupFormValidation(form);

    const browser = Bowser.getParser(window.navigator.userAgent);
    const submitButton = form.querySelector('button[type="submit"]');

    if (submitButton && browser.satisfies({
      macos: {chrome: '>121.0.0'}
    })) {
      const warning = document.createElement('p');
      warning.innerHTML = '<strong>Note:</strong> We have identified an unresolved issue with the latest version of Chrome which can affect file upload. If you are experiencing issues when uploading your document(s), please restart your browser (close out of the app and re-open) or try an alternative browser.';
      warning.style.fontStyle = 'italic';
      warning.style.lineHeight = '1.5';
      warning.style.fontSize = '14px';
      warning.style.marginBottom = '1rem';

      submitButton.insertAdjacentElement('beforebegin', warning);
    }

    for (const dropdown of form.querySelectorAll('[data-select-dropdown]')) {
      dropdown.dataset.validateHidden = 'true';
      setHandleFocus(dropdown, () => {
        dropdown.nextElementSibling.focus();
      });
    }
  }

  function setupNotificationForm() {
    const form = document.querySelector('[data-notification-form] form');

    if (!form) {
      return;
    }

    form.addEventListener('submit', (e) =>
      handleFormSubmit(e)
    );

    // emulate existing error placement logic so it doesn't conflict with bar styling for inputs
    setCreateErrorElement(form, (element, errorMessage) => {
      const errorElement = document.createElement('div');

      errorElement.classList.add('application-form__form-field-error-container');
      errorElement.classList.add('field-validation-error');
      errorElement.dataset.formFieldErrorContainer = 'true';
      errorElement.innerText = errorMessage;

      element.parentElement.appendChild(errorElement);

      return errorElement;
    });
    setupFormValidation(form);

    for (const dropdown of form.querySelectorAll('[data-select-dropdown]')) {
      dropdown.dataset.validateHidden = 'true';
      setHandleFocus(dropdown, () => {
        dropdown.nextElementSibling.focus();
      });
    }
  }

  setupApplicationForm();
  setupNotificationForm();
}

export default {
  init() {
    const $body = $('body');

    initMainNav();
    initNavDropdowns();

    if ($body.hasClass('legacy-skrollr')) {
      initLegacySkrollr(); // a few old pages need skrollr to be started for them
    }

    if (!$body.hasClass('has-custom-skrollr')) {
      initWOW(); // work pages don't use WOW
    }

    initScrollAnimations();
    initInputElements();
    initSmoothScrollingLinks();
    initContactForm();
    initCarouselAnimations();
    initCandidateApplicationForm();
    initShareTooltip();
  },
  finalize() {
    checkTrackingQuery();

    // fun logging for developers
    console.log('Hey there, taking a look under the hood?');
    console.log('Why not join us? ---->  https://www.konrad.com/careers');
  },
};
